// Canonical origin for byaft.com (the brand site). Keep in sync with index.html's
// canonical/og:url if the domain ever changes.
export const SITE_URL = 'https://byaft.com';
export const BRAND_NAME = 'BYAFT';

// Sibling sites linked from the brand pages.
export const TOOLS_URL = 'https://tools.byaft.com';
export const CYBER_URL = 'https://cyber.byaft.com';
